import {FileData} from "./fileData";
import {Dog} from "./dog";
import {User} from "./user";

export class FileLog {
    id: string;
    notes: string;
    file: FileData;
    type: string;
    dogId: string;
    dog: Dog;
    userId: string;
    user: User;
}



// WEBPACK FOOTER //
// ./src/classes/fileLog.ts